 <template>
  <div id="app">
    <SettingPassWord></SettingPassWord>
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive" :key="key"></router-view>
    </keep-alive> -->
    <!-- 不可以被缓存的视图组件 -->
    <!-- <router-view v-if="!$route.meta.keepAlive" :key="key"></router-view> -->
    <router-view />
  </div>
</template>
<script>
import SettingPassWord from "./components/settingPassWord";
import fakeClickOutSide from "./components/SelectOverFloow/fackClickOutSide";
import {
  PublicNewMsg,
  PublicOpinionFeedback,
  PublicCustomerService
} from "./store/socketsMessage";
export default {
  mixins: [fakeClickOutSide],
  data() {
    return {};
  },
  watch: {
    $route(val) {
      // if (val.fullPath !== "/login") {
      //   this.$socket.emit(
      //     "currentMenu",
      //     this.getCurrentMenu(val.fullPath),
      //     data => {}
      //   );
      //   if (val.fullPath !== "/case-8") {
      //     this.$socket.emit('setStatus', '', data => {})
      //   }
      // }
    }
  },
  components: {
    SettingPassWord
  },
  sockets: {
    leftMenuNumber(data) {
      if (typeof data === "string") {
        this.$websocket.dispatch("getLeftMenuNumber", JSON.parse(data));
      } else {
        this.$websocket.dispatch("getLeftMenuNumber", data);
      }
    }, 
    opinionFeedback(data) {
      if (this.$route.path != "/home") {
        this.PublicOpinionFeedback(data, this);
      }
    },
    //客服消息
    customerService(data) {
      if (this.$route.path != "/home") {
        this.PublicCustomerService(data, this);
      }
    }
  },
  created() {},
  computed: {
    key() { 
      return this.$route.path;
    }
  },
  methods: {
    PublicNewMsg: PublicNewMsg,
    PublicOpinionFeedback: PublicOpinionFeedback,
    PublicCustomerService: PublicCustomerService,
    getCurrentMenu(path) {
      switch (path) {
        case "/case":
          return "intoCase";
          break;
        case "/case-2":
          return "smallRoom";
          break;
        case "/case-3":
          return "task";
          break;
        case "/case-4":
          return "feedback";
          break;
        case "/case-5":
          return "patientFiles";
          break;
        case "/case-6":
          return "clockIn";
          break;
        case "/case-8":
          return "doctorNurse";
          break;
        case "/patientmanage":
          return "patient";
          break;
      }
    }
  }
};
</script>

<style lang="less">
@import "//at.alicdn.com/t/font_2510183_1j4zw9u76xj.css";
html,
body {
  height: 100%;
  width: 100%;
}
.popper {
  width: 200px;
}
#app {
  height: 100%;
  width: 100%;
}
.popverEmojClass {
  .emej {
    display: flex;
    flex-wrap: wrap;
    // justify-content: space-around;

    img {
      width: 30px;
      height: 30px;
      cursor: pointer;
    }
  }
}
// .el-textarea__inner{
//   resize: none!important;
// }
.set-opacity .el-input__count{ 
   background:rgba(220,38,38,0)!important
}
.group-dialog .el-dialog__footer{
  padding: 0 20px 40px;
  text-align: center;
}
.btn-form-item .el-form-item__content{
  margin: 12px 0 -18px!important;
  text-align: center;
}
.group-dialog .el-loading-parent--relative{
  padding-bottom: 1px;
}
.set-row-height .cell.el-tooltip{
  line-height: 28px;
}
</style>
